import React, { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import api from "../../api/api";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useDispatch } from "react-redux";

const RoomPopup = ({ isOpen, onClose,updateRoom,rowdata,fetchdata ,data}) => {
  const [selectedRoom, setSelectedRoom] = useState(null); // Selected room name
  const [providers, setProviders] = useState([]); // Room data from API
  const [groupedProviders, setGroupedProviders] = useState({}); // Grouped by type
  const [loading, setLoading] = useState(false); // Loading state
  const practiseid = window.getPracticeId();
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success');
    const [openToast, setOpenToast] = useState(false);
    const [patientInRoom, setPatientInRoom] = useState(null);
    const handleToastClose = () => {
      setOpenToast(false)
  };
const dispatch=useDispatch()
  const fetchRoomdata = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/v1/${practiseid}/rooms/get`);
      if (response.status === 200) {
        setProviders(response.data); // Accessing the data array
        // Group providers by type
        const grouped = response.data.reduce((acc, room) => {
         if (room.type !== 'North' && room.type !== 'South') { 
            if (!acc[room.type]) {
              acc[room.type] = [];
            }
            acc[room.type].push(room);
          }
          return acc;
        }, {});
        setGroupedProviders(grouped);
      } else {
        setProviders([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data when popup opens
  useEffect(() => {
    if (isOpen) {
      fetchRoomdata();
    }
  }, [isOpen]);

  // Handle room button click (only one room can be selected at a time)
  const handleButtonClick = (roomName) => {
    setSelectedRoom(roomName === selectedRoom ? null : roomName); 
    const occupiedRoom = data.find(room => room.room_no === roomName);
    if (occupiedRoom) {
      setPatientInRoom(occupiedRoom); // Set patient details if the room is occupied
    } else {
      setPatientInRoom(null);
    }
  };

// Define the mapping for room types to names
const roomTypeToName = {
  "Suite 106": "Madhu",
  "Suite 107": "Jaime",
  "Suite 105": "Oco"
};

  const handleUnassignPateint = async ({Pateints}) => {
    const PateintID=Pateints.patientid
    try {
      const response = await api.post(`/v1/${practiseid}/checkin/patient/${PateintID}/unassign`, {
       appointment_id: Pateints.appointmentid,
        token:Pateints.token,
        roomno: Pateints.room_no,
        rowid: Pateints.id
      });
      if (response.status === 200) {
        onClose()
        setToastMessage('Room Unassigned Successfully!')
        setToastSeverity('success');
        setOpenToast(true);
        fetchdata({})
      } else {
        console.error("Failed ");
        setToastMessage('Error unassigning room')
        setToastSeverity('error');
        setOpenToast(true);
      }
    } catch (error) {
      console.error("Error unassigning room:", error);
      setToastMessage('Please Assign Room ');
      setToastSeverity('error');
      setOpenToast(true);
        }
         finally {
    }
  };

  useEffect(() => {
    if (openToast) {
      setTimeout(() => {
        setOpenToast(false);
      }, 2000); // Auto close toast after 3 seconds
    }
  }, [openToast]);

  const handleAssignRoom = () => {
    if(patientInRoom){
      handleUnassignPateint({ Pateints: patientInRoom })
      updateRoom(selectedRoom);
    }
    else{
      if (selectedRoom) { // Ensure the room is selected before updating
      updateRoom(selectedRoom);
    
    }
  }
  setSelectedRoom('');
  onClose();
  setPatientInRoom(null)
  };
  
 const handleCloseModal=()=>{
  onClose();
  setPatientInRoom(null)
 }

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        {/* Popup Box */}
        <div className="relative flex flex-col gap-4 w-[35%] bg-white rounded-lg shadow-lg text-left">
          {/* Header */}
          <div>
            <div className="w-full flex items-center justify-between mt-2 px-4 py-2">
              <span className="ml-2 font-inter font-bold text-[#111827] text-base">
                Assign Room
              </span>
              <button
                className="text-gray-500 hover:text-gray-700 text-[30px]"
                onClick={handleCloseModal}
              >
                &times;
              </button>
            </div>
            <div className="h-px bg-[#D0D5DD]"></div>
          </div>

          {/* Grouped Room Buttons */}
          <div className="flex flex-col gap-4 max-h-[440px] overflow-y-auto custom-scrollbar p-4 pt-0">
            {patientInRoom ? (
              // Display message when room is occupied
              <>
                <button
                 onClick={() => handleUnassignPateint({ Pateints: patientInRoom })}
                 className={`bg-green-400 text-white rounded-[10px] py-2 px-4 w-[100%] transition duration-300 ease-in-out  bg-black border-2 text-gray-500 cursor-not-allowed'`}
               >
                 Unassign Room
               </button>
              <div className="text-center text-lg font-semibold text-[#E17954]">
                {`${patientInRoom.room_no} is currently being used by ${patientInRoom.firstname} ${patientInRoom.lastname}`}
              </div>
             
               </>
            ) : (
              <>
                <button
                  onClick={() => handleUnassignPateint({ Pateints: rowdata })}
                  className={`bg-green-400 text-white rounded-[10px] py-2 px-4 w-[100%] transition duration-300 ease-in-out  bg-black border-2 text-gray-500 cursor-not-allowed'`}
                >
                  Unassign Room
                </button>

                {loading
                  ? [...Array(6)].map((_, index) => (
                      <Skeleton
                        key={index}
                        variant="rectangular"
                        width={100}
                        height={40}
                        sx={{ borderRadius: "20px" }}
                      />
                    ))
                  : Object.entries(groupedProviders).map(([type, rooms]) => (
                      <div key={type} className="flex flex-col gap-2">
                        <span className="font-inter text-[13px] font-Font1 text-[#111827]"> {roomTypeToName[type] || type}:</span>
                        <div className="flex flex-wrap gap-4">
                          {rooms.map((room, index) => (
                            <button
                              key={index}
                              onClick={() => handleButtonClick(room.room)}
                              className={`rounded-full border-[1.5px] border-gray-200 text-sm font-inter py-2 px-4 transition duration-300 ease-in-out 
                                ${selectedRoom === room.room ? "bg-[#E17954] text-white" : "bg-[#F3F3F3] text-[#1D2951]"} 
                                hover:bg-[#E17954] hover:text-[#FFFFFF]`}
                            >
                              {room.room}
                            </button>
                          ))}
                        </div>
                      </div>
                    ))}
              </>
            )}
          </div>

          {/* Update Button */}
     
            <div className="flex items-center justify-center border-t bg-[#F9FAFB] p-3 rounded-[10px]">
              <button
                onClick={handleAssignRoom}
                disabled={!selectedRoom} // Disable the button when no room is selected
                className={`bg-[#18181B] text-white rounded-[10px] py-2 px-4 w-[90%] transition duration-300 ease-in-out  
                  ${selectedRoom ? 'bg-[#black] text-[#FFFFFF] cursor-pointer' : 'bg-black border-2 text-gray-500 cursor-not-allowed'}`}
              >
                Assign Room
              </button>
            </div>
         
        </div>
        <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
      </div>
    )
  );
};

export default RoomPopup;
